import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const ModalWrapper = styled(Modal)`
  .modal-dialog {
    max-width: 800px;
  }

  .modal-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    
    .modal-title {
      color: #495057;
      font-weight: 600;
    }
  }

  .modal-body {
    padding: 2rem;
  }

  .modal-footer {
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    padding: 1rem 2rem;
  }
`;

export const Container = styled.div`
  .form-label {
    color: #495057;
    font-weight: 500;
    margin-bottom: 0.5rem;
  }

  .form-select {
    border: 1px solid #ced4da;
    border-radius: 0.375rem;
    padding: 0.75rem;
    
    &:focus {
      border-color: #86b7fe;
      box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    }
  }

  h6 {
    color: #495057;
    margin-bottom: 1rem;
    
    &.text-primary {
      color: #0d6efd !important;
      font-weight: 600;
      font-size: 1rem;
      display: flex;
      align-items: center;
      
      i {
        color: #0d6efd;
        margin-right: 0.5rem;
        font-size: 0.9rem;
      }
      
      &.border-bottom {
        border-bottom: 2px solid #e9ecef !important;
        padding-bottom: 0.5rem;
        margin-bottom: 1rem;
      }
    }
  }

  .bg-light {
    background-color: #f8f9fa !important;
    border: 1px solid #e9ecef;
  }

  /* Estilos para as seções */
  .mb-4 {
    background-color: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 1.5rem;
    margin-bottom: 1.5rem !important;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    transition: box-shadow 0.15s ease-in-out;
    
    &:hover {
      box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
    }
  }

  /* Estilos para os checkboxes */
  .form-check {
    margin-bottom: 0.75rem;
    
    .form-check-input {
      margin-top: 0.25rem;
      
      &:checked {
        background-color: #0d6efd;
        border-color: #0d6efd;
      }
      
      &:focus {
        border-color: #86b7fe;
        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
      }
    }
    
    .form-check-label {
      color: #495057;
      font-weight: 500;
      cursor: pointer;
      margin-left: 0.5rem;
      
      &:hover {
        color: #0d6efd;
      }
    }
  }

  /* Estilos específicos para seção de impressoras */
  .mb-4:has(h6:contains("Locais de Impressão")) {
    .row {
      max-height: 300px;
      overflow-y: auto;
      
      &::-webkit-scrollbar {
        width: 6px;
      }
      
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }
      
      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
      }
      
      &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
      }
    }
  }
`;

export const CategoriasList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 1rem;
  background-color: #fff;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const CategoriaItem = styled.div`
  padding: 0.5rem 0;
  border-bottom: 1px solid #f1f1f1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  &:last-child {
    border-bottom: none;
  }

  .form-check {
    margin-bottom: 0;
    
    .form-check-input {
      margin-top: 0.125rem;
    }
    
    .form-check-label {
      color: #495057;
      font-weight: 500;
      cursor: pointer;
      
      &:hover {
        color: #0d6efd;
      }
    }
  }

  small {
    margin-left: 1.5rem;
    font-style: italic;
  }
`;